"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollToElement = exports.modifySection = exports.isValidEmail = exports.modifyContentInSection = exports.isFormValid = exports.setButtonEnabledState = exports.getHiddenFieldValue = exports.setUiState = exports.processQueryStringParameters = exports.hasValue = exports.isPostcodeValid = exports.isPostalAreaValid = exports.clearAndHideInfoBar = exports.handleAlertAreaDisplay = exports.scrollToTop = exports.scrollToBottom = exports.resetWarningLightsSelection = exports.warningLightsChecked = exports.changeMultipleElementVisibility = exports.changeElementVisibility = exports.handleCheckBoxClick = exports.handleRadioGroupClick = exports.resetErrors = exports.getFieldErrorsOnSubmittedForm = exports.handleSubmit = exports.getCurrentPage = exports.sessionExpired = exports.resetSessionTimer = exports.validateModel = exports.validateInputsForModel = exports.showRetailerInfoDialog = exports.showSiteMaintenanceDialog = exports.bindPageShowEvent = exports.encodeForUrlTransit = exports.setNavigationStepStates = exports.bindAddVehicleClick = exports.bindMileageInputKeyUp = exports.bindMileageInputKeyDown = exports.bindNewVehicleMileageInputKeyDown = exports.bindNewVehicleMileageInputKeyUp = exports.bindSelectVehicleLinkClick = exports.bindNewVehicleNumberPlateInputKeyDown = exports.setAddButtonState = exports.getTime = exports.setFocusOnElement = exports.setupCommon = exports._setupValidationMsg = exports._route = exports._alertArea = exports._infoBar = void 0;
exports.bindFormSubmit = exports.TabbedContent = exports.centreElement = exports.hideOverlay = exports.showOverlay = exports.vehicleHasServicePack = void 0;
var animator = require("../../../wwwroot/images/loadingAnimator.json");
var logging_1 = require("../core/logging");
var network_1 = require("./network");
var lottie_web_1 = __importDefault(require("lottie-web"));
var alert_control_1 = require("./alert-control");
var read_more_control_1 = require("./read-more-control");
exports._infoBar = ".informationBar";
exports._alertArea = ".alertArea";
exports._route = "#Route";
exports._setupValidationMsg = "#SetupLocalisedValidationMessage";
var _transitionInMs = 1000;
var _sessionCheckIntervalSeconds = 10;
var _slideTransitionInMs = 500;
var _sessionTimer = null;
var _remainingSessionSeconds;
var _selectedServices;
$(function () {
    (0, logging_1.logScriptLoad)("[core-common]");
    (0, logging_1.log)("Version: " + $("#BuildVersion").text() + " | Timestamp: " + $("#BuildTimestamp").text(), 3 /* LogType.Information */, "BUILD");
});
/** This method must only be called ONCE for each page otherwise duplicate event-handlers will be setup. */
function setupCommon() {
    // This is required as the html for Retail & Corp is slightly different with regards to the Service List layout
    _selectedServices = $("#invisibleListWrapper").length ? "#ServiceList > #invisibleListWrapper input:checked" : "#ServiceList input:checked";
    setupAlertArea();
    handleAlertAreaDisplay();
    initSessionTimer();
    setFocusOnFirstInput();
    bindPageShowEvent();
    loadProgressAnimation();
    setupBasket();
    setupFooterControl();
    setupCookieBannerObserver();
    setupAccordions();
    $("a").on("click", function () {
        if (!$(this).hasClass("no-progress")
            && !$(this).hasClass("help-link")
            && !$(this).hasClass("toolTip")
            && !$(this).hasClass("overlayFire")
            && $(this).parent(".no-progress").length === 0) {
            setUiState("Busy" /* Ui.Busy */);
        }
        else {
            (0, logging_1.log)("element has a class indicating spinner should not be shown.", 4 /* LogType.Debug */, "{core-common - anchor click event}");
        }
    });
    $(document).on("click", ".alertClose", function (ev) {
        ev.preventDefault();
        $(".alertArea").fadeOut("slow");
    });
    $(document).on("keydown", function (ev) {
        if (ev.key === "Escape") {
            hideOverlay();
        }
    });
    $(document).on("click", ".toolTip", function (ev) {
        ev.preventDefault();
        var id = $(this).attr("id");
        var content = $(this).hasClass("jobInformationLink")
            ? $(".JobInformation" + $(this).data("jobcode")).val()
            : $("#" + id + "__Wrapper").html();
        if (content) {
            showOverlay(content);
        }
    });
    $(document).on("click", ".communication-info", function (ev) {
        ev.preventDefault();
        showOverlay($("#CommunicationInfo").val());
    });
    $(document).on("click", ".service-pack-terms-and-conditions", function (ev) {
        ev.preventDefault();
        showOverlay($("#ServicePackTermsAndConditions").val());
    });
    $(document).on("click", ".mp-withdraw-consent-info", function (ev) {
        ev.preventDefault();
        showOverlay($("#WithdrawConsentInfo").val());
    });
    $(document).on("click", ".promotion-terms-and-conditions", function (ev) {
        ev.preventDefault();
        showOverlay($("#personalisedPricing_Wrapper").html());
    });
    $(".expander").off("click").on("click", function () {
        var $triggeringElement = $(this);
        if ($(this).parent().find('.content').is(':animated')) { // check if content animation is in progress
            return false; // stop trigger event if so
        }
        if ($(this).hasClass("closes-other-expanders")) {
            $(".expander").each(function () {
                if (!$triggeringElement.is($(this))) {
                    var $targetContent = $(this).parent().find(".content");
                    $targetContent.hide("slow");
                    $(this).addClass("closed").removeClass("open");
                }
            });
        }
        $(this).toggleClass("closed open");
        var $content = $(this).parent().find(".content");
        var newState = $(this).hasClass("open") ? "Open" /* UiState.Open */ : "Close" /* UiState.Close */;
        modifyContentInSection($content, newState);
    });
    $(".js-close-modal").on("click", function () {
        hideOverlay();
    });
    $(".modalInner").on('click', '.js-close-modal', function () {
        hideOverlay();
    });
    $(".menuCloseBtn").on("click", function (ev) {
        ev.preventDefault();
    });
    $("button").on("click", function () {
        var source = $(this).prop("id") || $(this).prop("name") || $(this).prop("class");
        (0, logging_1.log)("element: " + source, 4 /* LogType.Debug */, "Button click {event}");
    });
    bindFormSubmit();
    $(".step-progress a").off("click").on("click", function () {
        (0, logging_1.log)("Navigation clicked, show progress Ui.", 4 /* LogType.Debug */, "Nav Step click");
        setUiState("Busy" /* Ui.Busy */);
    });
    $(".to-upper-case").on("keyup", function (ev) {
        $(this).val($(this).val().toString().toUpperCase());
    });
    $(".remove-spaces").on("keyup", function (ev) {
        $(this).val($(this).val().toString().replace(" ", ""));
    });
    //Checkbox and radio button selection add checked
    $(document).on("click", ".selectButtons label", function (e) {
        (0, logging_1.log)("Event.", 4 /* LogType.Debug */, ".selectButtons label {click}");
        var src = $(this);
        if (src.hasClass("waiting-option-has-no-availability")) {
            (0, logging_1.log)("waiting-option-has-no-availability class clicked", 4 /* LogType.Debug */, ".selectButtons label {click}");
            return;
        }
        src.siblings().removeClass("checked");
        src.addClass("checked");
        if (src.hasClass("dateChoose")) {
            // Corp only UI element manipulation
            $(".corp-std-booking-radio:radio").prop("checked", false);
            var defaultValue = $("#DefaultCorpRadioButtonValue").val();
            if (defaultValue) {
                var defaultRadioButton = $(src).closest(".waiting-option-container").find(".corp-std-booking-radio:radio[value=\"".concat(defaultValue, "\"]"));
                // Set the expected 'default' radio button after selecting a date
                if (defaultRadioButton.length > 0) {
                    $(defaultRadioButton).prop("checked", true);
                }
            }
        }
    });
    $(document).on("keyup", "#customer-details-for-callback input", function () {
        if ($("#customer-details-for-callback-email").val()
            && $("#customer-details-for-callback-telephone").val()
            && $("#customer-details-for-callback-forename").val()
            && $("#customer-details-for-callback-surname").val()
            && isValidEmail($("#customer-details-for-callback-email").val())) {
            $("#sendCustomerDetailsToRetailer").prop("disabled", false);
        }
        else {
            $("#sendCustomerDetailsToRetailer").prop("disabled", true);
        }
    });
    $(document).on("click", "#UnifiedConsent", function () {
        var newState;
        var $content = $("p.marketing-preferences").parent().find(".content");
        if ($(this).is(":checked")) {
            $(".communication-channel-selected").prop("checked", true);
            $("p.marketing-preferences").addClass("closed").removeClass("open");
            newState = "Close" /* UiState.Close */;
        }
        else {
            $(".communication-channel-selected").prop("checked", false);
            $("p.marketing-preferences").addClass("open").removeClass("closed");
            newState = "Open" /* UiState.Open */;
        }
        modifyContentInSection($content, newState);
    });
    $(document).on("click", ".communication-channel-selected", function () {
        var source = this;
        if (!$(source).prop("checked")) {
            $(".unified-consent-checkbox").prop("checked", false);
        }
    });
    $(document).on("click", "#sendCustomerDetailsToRetailer", function (ev) {
        return __awaiter(this, void 0, void 0, function () {
            var url, jsonResult, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        $(this).hide();
                        url = "/clientapi/requestCustomerCallback"
                            + "?rooftop=".concat($("#Retailer_RooftopId").val())
                            + "&email=".concat($("#customer-details-for-callback-email").val())
                            + "&telephone=".concat($("#customer-details-for-callback-telephone").val())
                            + "&forename=".concat($("#customer-details-for-callback-forename").val())
                            + "&surname=".concat($("#customer-details-for-callback-surname").val());
                        if (!(url.indexOf("//") === -1)) return [3 /*break*/, 6];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, network_1.network.fetchData(url)];
                    case 2:
                        jsonResult = _a.sent();
                        $(".retailer-contact-info .sending-callback-request").show();
                        $(".retailer-contact-info .sent-callback-request").fadeIn();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        $(".retailer-contact-info .callback-request-failed").fadeIn();
                        return [3 /*break*/, 5];
                    case 4:
                        $(".retailer-contact-info .sending-callback-request").hide();
                        $(".retailer-contact-info .intro").hide();
                        $(".retailer-contact-info .contact-retailer-directly").hide();
                        $(".retailer-contact-info .send-customer-details-to-retailer").hide();
                        $(".retailer-contact-info .send-customer-details-to-retailer img").show();
                        return [7 /*endfinally*/];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        // we built an invalid API endpoint so just bale immediately
                        $(".retailer-contact-info .callback-request-failed").fadeIn();
                        $(".retailer-contact-info .intro").hide();
                        $(".retailer-contact-info .sending-callback-request").hide();
                        $(".retailer-contact-info .contact-retailer-directly").hide();
                        $(".retailer-contact-info .send-customer-details-to-retailer").hide();
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    });
    $(document).on("click", ".navStepBtn", function (ev) {
        try {
            var source = $(this);
            if (source.hasClass("nextSection") || source.hasClass("nextButton")) {
                var currentTab = $("#recommendedTabs li.current");
                if (currentTab.attr("id") === "recommendedContentTab" && currentTab.is(":visible")) {
                    // don't process the normal section change if we are currently showing the recommended tab in the estimate
                    // a seperate event handler will pick up and process the tab switch
                    return;
                }
            }
            var invalid = true;
            var navStepId = $(this).attr("navstepid");
            if (navStepId) {
                var id = parseInt(navStepId);
                if (!isNaN(id)) {
                    var step = id;
                    setNavigationStepStates(step);
                    changeMultipleElementVisibility($(this).attr("elementsLinkJson"));
                    if (step === 5 /* NavStep.Servicing */) {
                        //Show skip to tyres nav
                        $(".stepSection.tyres").removeClass("hidden");
                    }
                    else if (step === 6 /* NavStep.Tyres */) {
                        // If we have a service item in the basket and we're on the first tyres page 
                        // show skip to appointment nav
                        if ($(_selectedServices).length > 0
                            && !$("[elementLinkId='tyres']").hasClass("hidden")) {
                            $(".stepSection.accessories").removeClass("hidden");
                        }
                    }
                    else if (step === 7 /* NavStep.Accessories */) {
                        // If we have a service item in the basket and we're on the accessories page
                        // show skip to appointment nav
                        if ($(_selectedServices).length > 0
                            && !$("[elementLinkId='accessoriesFormStep']").hasClass("hidden")) {
                            $(".stepSection.appointment").removeClass("hidden");
                        }
                    }
                    invalid = false;
                    scrollToTop();
                }
            }
            if (invalid) {
                (0, logging_1.log)("Received an invalid or missing navstepid from .navStepBtn button.", 1 /* LogType.Error */, ".navStepBtn {click}");
            }
        }
        catch (ex) {
            (0, logging_1.log)(ex.message, 1 /* LogType.Error */, ".navStepBtn {click}");
        }
        finally {
            setUiState("Ready" /* Ui.Ready */);
        }
    });
    $(document).on("click", ".stepSection", function () {
        $(".stepSection").addClass("hidden").hide();
    });
    $(".iconChecks .check-box").on("click", function () {
        warningLightsChecked();
        var elementLink = $(this).attr("elementLink");
        var elementLinkProp = $(this).prop("checked");
        var elementAction = elementLinkProp ? "show" : "hide";
        elementLink && elementAction ? changeElementVisibility(elementLink, elementAction) : null;
    });
    $("#returnToVehicleStepBtn").on("click", function () {
        // Reset selection options
        $("#book-service").prop("checked", false);
        $("#not-sure").prop("checked", false);
        $("#warningNo").prop("checked", false);
        $("#warningYes").prop("checked", false);
        $('.serviceListWrapper').find("[elementLinkId]").hide();
        $('#warningLights input[type="checkbox"]').prop('checked', false);
        $('[elementLinkId=warningLights]').hide();
        $('[elementLinkId=warningLightsList]').hide();
        $("[elementLinkId=seeServices]").attr("disabled", "disabled");
        //hide basket on mobile
        $(".mobileBasket").removeClass("show");
    });
    $('.is-numeric').on("keydown", function (ev) {
        var permittedNonDigits = ["ArrowLeft", "ArrowRight", "Backspace", "Delete", "Home", "End", "Enter", "Tab", "F5", "F10", "F12"];
        if (permittedNonDigits.indexOf(ev.key) > -1) {
            return;
        }
        if (ev.key === " " || !isFinite(Number(ev.key))) {
            ev.preventDefault();
        }
    });
}
exports.setupCommon = setupCommon;
function setFocusOnElement(selector) {
    var _a, _b;
    try {
        if (selector) {
            var $element = $(selector);
            if ($element.length > 0) {
                $(selector).first().focus();
                var id = (_b = (_a = $element.attr("id")) !== null && _a !== void 0 ? _a : $element.attr("name")) !== null && _b !== void 0 ? _b : "unspecified";
                (0, logging_1.log)("Set focus to element ".concat(id, "."), 4 /* LogType.Debug */, "setFocusOnElement");
            }
        }
    }
    catch (e) { }
}
exports.setFocusOnElement = setFocusOnElement;
;
function getTime() {
    var now = new Date();
    var result = "".concat(now.getHours(), ":").concat(now.getMinutes() < 10 ? "0" : "").concat(now.getMinutes(), ".").concat((now.getSeconds() < 10 ? "0" : "")).concat(now.getSeconds());
    return result;
}
exports.getTime = getTime;
function setAddButtonState() {
    var mileage = $('.add-vehicle-current-mileage-input').val().toString();
    if ($(".add-vehicle-number-plate-input").val() && mileage.length > 0 && parseInt(mileage)) {
        $("#addVehicleButton").removeProp("disabled").removeAttr("disabled");
    }
    else {
        $("#addVehicleButton").prop("disabled", true);
    }
}
exports.setAddButtonState = setAddButtonState;
function bindNewVehicleNumberPlateInputKeyDown() {
    $('.add-vehicle-number-plate-input').keyup(function (ev) {
        var invalid = $(this).val().toString().length === 0;
        $(this).toggleClass("input-validation-error", invalid);
        if (invalid) {
            $(this).next("span").removeClass("field-validation-valid").addClass("field-validation-error").text("Number plate is required.");
        }
        else {
            $(this).next("span").removeClass("field-validation-error").addClass("field-validation-valid").text("");
        }
        setAddButtonState();
    });
}
exports.bindNewVehicleNumberPlateInputKeyDown = bindNewVehicleNumberPlateInputKeyDown;
function bindSelectVehicleLinkClick() {
    $('.selectVehicleLink').click(function () {
        $('.current-mileage-input').val('');
        $('.selectVehicleLink').removeClass("selected");
        $(this).addClass("selected");
        $('.vehicleSelectBox').hide();
        //show selected vehicle container
        $('.vehicleSelectBox[data-key="' + $(this).data('key') + '"]').fadeIn('slow', function () {
            $('.selected-vehicle[data-key="' + $(this).data('key') + '"]').click();
            $("form").validate().resetForm();
            $("label.error").hide();
            $(".error").removeClass("error");
            $('.current-mileage-input[data-key="' + $(this).data("key") + '"]').focus();
        });
    });
}
exports.bindSelectVehicleLinkClick = bindSelectVehicleLinkClick;
function bindNewVehicleMileageInputKeyUp() {
    $('.add-vehicle-current-mileage-input').keyup(function (ev) {
        setAddButtonState();
    });
}
exports.bindNewVehicleMileageInputKeyUp = bindNewVehicleMileageInputKeyUp;
function bindNewVehicleMileageInputKeyDown() {
    $('.add-vehicle-current-mileage-input').keydown(function (ev) {
        if (!isFinite(Number(ev.key)) && ev.key !== "Backspace" && ev.key !== "Delete" && ev.key !== "Tab" && ev.key != "Enter") {
            ev.preventDefault();
        }
    });
}
exports.bindNewVehicleMileageInputKeyDown = bindNewVehicleMileageInputKeyDown;
function bindMileageInputKeyDown() {
    $('.current-mileage-input').keydown(function (ev) {
        if (!isFinite(Number(ev.key)) && ev.key !== "Backspace" && ev.key !== "Delete" && ev.key !== "Tab" && ev.key != "Enter") {
            ev.preventDefault();
        }
        var invalid = $(this).val().toString().length === 0 || !parseInt($(this).val().toString());
        $(this).parent().parent().find('#confirmVehicle').prop('disabled', invalid);
    });
}
exports.bindMileageInputKeyDown = bindMileageInputKeyDown;
function bindMileageInputKeyUp() {
    $('.current-mileage-input').keyup(function (ev) {
        $(".selected-current-mileage").val($(this).val());
        var invalid = $(this).val().toString().length === 0 || !parseInt($(this).val().toString());
        $(this).parent().parent().find('#confirmVehicle').prop('disabled', invalid);
    });
}
exports.bindMileageInputKeyUp = bindMileageInputKeyUp;
function bindAddVehicleClick() {
    $("#addVehicle").click(function () {
        $(".add-vehicle-number-plate-input").val("");
        $(".add-vehicle-current-mileage-input").val("");
        if ($(this).is(":checked")) {
            $(".addVehicle").fadeIn("slow").removeClass("hidden");
            $(".vehicleSelectBox.addVehicle").fadeIn("slow", function () {
                $(".add-vehicle-number-plate-input").focus();
            });
        }
        else {
            $(".addVehicle").addClass("hidden").hide();
        }
    });
}
exports.bindAddVehicleClick = bindAddVehicleClick;
function setNavigationStepStates(activeStep) {
    var $activeSteps = $(".progressBar li[data-ui-step='" + activeStep + "']");
    $activeSteps.toggleClass("active current", true);
    var $allSteps = $(".progressBar li");
    $allSteps.each(function (i, step) {
        $(step).toggleClass('active', $(step).data("ui-step") <= activeStep);
        $(step).find('a').toggleClass('disabled', $(step).data("ui-step") > activeStep);
    });
    var lastActiveStep = $allSteps.filter('.active').last();
    if (lastActiveStep.length) {
        var stepNumber = lastActiveStep.data("ui-step");
        var matchingField = $('li[data-ui-step="' + stepNumber + '"]');
        if (matchingField.length) {
            $("#ActiveStep").val(matchingField.data("step"));
        }
    }
}
exports.setNavigationStepStates = setNavigationStepStates;
;
function encodeForUrlTransit(input) {
    (0, logging_1.log)("input: " + input, 4 /* LogType.Debug */, "encodeForUrlTransit");
    var output = encodeURIComponent(input).replace(/[!"()]/g, escape).replace(/\*/g, "%2A");
    (0, logging_1.log)("output: " + output, 4 /* LogType.Debug */, "encodeForUrlTransit");
    return output;
}
exports.encodeForUrlTransit = encodeForUrlTransit;
;
function bindPageShowEvent() {
    try {
        window.addEventListener('pageshow', function (event) {
            if (event.persisted) {
                setUiState("Ready" /* Ui.Ready */);
                (0, logging_1.log)('Page restored from bfcache.', 4 /* LogType.Debug */, 'pageshow event');
            }
            else {
                (0, logging_1.log)('Page loaded normally.', 4 /* LogType.Debug */, 'pageshow event');
            }
        });
    }
    catch (ex) { }
}
exports.bindPageShowEvent = bindPageShowEvent;
;
function showSiteMaintenanceDialog() {
    showOverlay($("#siteMaintenance__Wrapper").html(), "small" /* ModalSize.Small */);
}
exports.showSiteMaintenanceDialog = showSiteMaintenanceDialog;
;
function showRetailerInfoDialog() {
    showOverlay($("#customerCallback__Wrapper").html(), "small" /* ModalSize.Small */);
}
exports.showRetailerInfoDialog = showRetailerInfoDialog;
;
function validateInputsForModel(model) {
    var invalidCount = 0;
    var targetAttr = "data-model='" + model + "'";
    $("input[" + targetAttr + "], select[" + targetAttr + "]").each(function () {
        if (!$(this).valid()) {
            invalidCount++;
            console.log("Field [" + $(this).attr("id") + "] invalid.");
        }
    });
    console.log("There are [" + invalidCount + "] invalid fields on model [" + model + "]");
    return invalidCount;
}
exports.validateInputsForModel = validateInputsForModel;
;
function validateModel(model, continueSelector, disableContinueIfInvalid, continueFunction, continueArgs) {
    var $modelInputs = $("input[data-model='" + model + "']");
    $($modelInputs).each(function () {
        $(this).blur(function () {
            var invalidCount = validateInputsForModel(model);
            if (disableContinueIfInvalid && continueSelector) {
                if (invalidCount > 0) {
                    $(continueSelector).attr("disabled", "disabled");
                }
                else {
                    $(continueSelector).removeAttr("disabled");
                }
            }
        });
    });
    if (continueSelector) {
        $(continueSelector).click(function (ev) {
            if (validateInputsForModel(model) > 0) {
                ev.preventDefault();
                if (disableContinueIfInvalid) {
                    $(continueSelector).attr("disabled", "disabled");
                }
            }
            else {
                if (disableContinueIfInvalid) {
                    $(continueSelector).removeAttr("disabled");
                }
                if (continueFunction) {
                    $.when(continueFunction.apply(this, continueArgs)).then(function () {
                        console.debug("Proceeding.");
                    });
                }
            }
        });
    }
}
exports.validateModel = validateModel;
;
function initSessionTimer() {
    (0, logging_1.log)("invoked", 4 /* LogType.Debug */, "initSessionTimer");
    if (_sessionTimer === null) {
        _remainingSessionSeconds = calculateSessionDurationInSeconds();
        if (_remainingSessionSeconds) {
            _sessionTimer = setInterval(checkSession, _sessionCheckIntervalSeconds * 1000);
        }
    }
}
;
function calculateSessionDurationInSeconds() {
    var target = $("#SessionDuration");
    if ($(target).length === 0) {
        return 0;
    }
    var durationInMins = parseInt($("#SessionDuration").val().toString());
    return durationInMins * 60;
}
function checkSession() {
    _remainingSessionSeconds = _remainingSessionSeconds - _sessionCheckIntervalSeconds;
    (0, logging_1.log)("Session has ".concat(_remainingSessionSeconds, " seconds remaining"), 4 /* LogType.Debug */, "checkSession");
    if (_remainingSessionSeconds <= 0) {
        sessionExpired();
    }
}
function resetSessionTimer() {
    (0, logging_1.log)("invoked", 4 /* LogType.Debug */, "resetSessionTimer");
    _remainingSessionSeconds = calculateSessionDurationInSeconds();
}
exports.resetSessionTimer = resetSessionTimer;
;
function sessionExpired() {
    (0, logging_1.log)("invoked", 4 /* LogType.Debug */, "sessionExpired");
    //re-direct to home page on time-out
    window.location.href = "/?error=1&info=session+expired";
}
exports.sessionExpired = sessionExpired;
;
function getCurrentPage() {
    var href = window.location.href;
    if (href.endsWith("/")) {
        href = href.substring(0, href.length - 1);
    }
    return href.split("/").pop().toLowerCase().trim();
}
exports.getCurrentPage = getCurrentPage;
;
function setFocusOnFirstInput() {
    try {
        var settingEnabled = $('#SetFocusOnFirstInput').val() === "1";
        if (settingEnabled) {
            var firstInput_1 = $("form").first().find("input[type=text],input[type=textarea],input[type=select]").first();
            if (firstInput_1) {
                (0, logging_1.log)("set focus on: " + $(firstInput_1).attr("id"), 4 /* LogType.Debug */, "setFocusOnFirstInput");
                // ensures the element is rendered before setting focus
                setTimeout(function () { $(firstInput_1).focus(); }, 0);
            }
        }
    }
    catch (_a) { }
}
;
function handleSubmit(form, canSubmit) {
    (0, logging_1.log)("Invoked.", 4 /* LogType.Debug */, "handleSubmit");
    if (form && canSubmit) {
        resetErrors();
        setUiState("Busy" /* Ui.Busy */);
        form[0].submit();
    }
}
exports.handleSubmit = handleSubmit;
;
function getFieldErrorsOnSubmittedForm(form) {
    var fieldsInError = null;
    if (form) {
        fieldsInError = $(form).find(".input-validation-error:visible");
    }
    return fieldsInError;
}
exports.getFieldErrorsOnSubmittedForm = getFieldErrorsOnSubmittedForm;
;
function resetErrors() {
    //Removes validation from input-fields
    $(".input-validation-error").addClass("input-validation-valid");
    $(".input-validation-error").removeClass("input-validation-error");
    //Removes validation message after input-fields
    $(".field-validation-error").addClass("field-validation-valid");
    $(".field-validation-error").removeClass("field-validation-error");
    //Removes validation summary
    $(".validation-summary-errors").addClass("validation-summary-valid");
    $(".validation-summary-errors").removeClass("validation-summary-errors");
}
exports.resetErrors = resetErrors;
;
function handleRadioGroupClick(clickedRadio) {
    (0, logging_1.log)("Invoked.", 4 /* LogType.Debug */, "handleRadioGroupClick");
    if (clickedRadio) {
        var id = $(clickedRadio).attr("id");
        var $radioGroup = $("input[name=" + $(clickedRadio).attr("name") + "]:radio");
        var elementLink = $(clickedRadio).attr("elementLink");
        var elementAction = $(clickedRadio).attr("elementAction");
        var elementsLinkJson = $(clickedRadio).attr("elementsLinkJson");
        $($radioGroup).removeAttr("checked");
        $($radioGroup).prop("checked", false);
        $($radioGroup).closest("label").toggleClass("checked", false);
        $(clickedRadio).attr("checked", "checked");
        $(clickedRadio).prop("checked", true);
        (0, logging_1.log)("Radio button [id: " + id + "] [value: " + $(clickedRadio).val() + "] selected.", 4 /* LogType.Debug */, "handleRadioGroupClick");
        $(clickedRadio).closest("label").toggleClass("checked", true);
        // - Change element visibility of connected div class if elementLink and elementAction is present or multiple classes is elementsLinkJson is an attr
        // - To change visibility of multiple classes add the class names and actions to the elementLinkJson data attribute on the element
        // - elementLinkJson follows the format { 'class name 1': 'action 1', 'class name 2', 'action 2' } where action is "show" or "hide"
        // - e.g. single element <input type="radio" elementLink="wrapperDiv" elementAction="hide" value="Radio 1" />
        // - e.g. multiple elements <input type="radio" elementsLinkJson='{ "wrapperDiv1": "show", "wrapperDiv2": "hide" }' value="Radio 2" />
        // - N.B. The elemementsLinkJson *must* be contained in single (') not double (") quotes for it to be parsed correctly
        elementLink && elementAction ? changeElementVisibility(elementLink, elementAction) : null;
        elementsLinkJson ? changeMultipleElementVisibility(elementsLinkJson) : null;
        // if warningNo radio id selected reset warning lights form
        id === "warningNo" ? (resetWarningLightsSelection(), setButtonEnabledState($("#seeServices"), true)) : null;
        id === "warningYes" ? setButtonEnabledState($("#seeServices"), false) : null;
        id === "tyresSkipYes" ? $("#tyreSizes").show() : null;
        id === "tyresSkipNo" ? $("#tyreSizes").hide() : null;
    }
}
exports.handleRadioGroupClick = handleRadioGroupClick;
;
function handleCheckBoxClick(clickedCheckBox) {
    (0, logging_1.log)("Invoked.", 4 /* LogType.Debug */, "handleCheckBoxClick");
    if (clickedCheckBox) {
        var id = $(clickedCheckBox).attr("id");
        if (id === "priceOnArrival") {
            clickedCheckBox.checked ? setButtonEnabledState($(".proceedToAppointmentNextBtn"), true) : setButtonEnabledState($(".proceedToAppointmentNextBtn"), false);
        }
    }
}
exports.handleCheckBoxClick = handleCheckBoxClick;
;
function changeElementVisibility(elementLink, action) {
    (0, logging_1.log)("Single Show/Hide function called for " + elementLink + " : " + action, 4 /* LogType.Debug */, "changeElementVisibility");
    //let target = $("form").find(`[elementLinkId=` + elementLink + `]`);
    var target = $(document).find("[elementLinkId=" + elementLink + "]");
    action === "show"
        ? $(target).removeClass("hidden").show()
        : $(target).addClass("hidden").hide();
}
exports.changeElementVisibility = changeElementVisibility;
function changeMultipleElementVisibility(elementsLinkJson) {
    var elementsToShowHide = JSON.parse(elementsLinkJson);
    for (var key in elementsToShowHide) {
        if (elementsToShowHide.hasOwnProperty(key)) {
            (0, logging_1.log)("Multiple Show/Hide function called for " + key + " : " + elementsToShowHide[key], 4 /* LogType.Debug */, "changeMultipleElementVisibility");
            changeElementVisibility(key, elementsToShowHide[key]);
        }
    }
}
exports.changeMultipleElementVisibility = changeMultipleElementVisibility;
function warningLightsChecked() {
    var numberOfWarningLightsChecked = $('.iconChecks').find('input[type=checkbox]:checked').length;
    numberOfWarningLightsChecked > 0 ? setButtonEnabledState($("#seeServices"), true) : setButtonEnabledState($("#seeServices"), false);
}
exports.warningLightsChecked = warningLightsChecked;
function resetWarningLightsSelection() {
    $('.iconChecks .check-box').each(function () {
        $(this).prop('checked') ? ($(this).click(), changeElementVisibility($(this).attr("elementLink"), "hide")) : null;
    });
    (0, logging_1.log)("Reset all warning light selection", 4 /* LogType.Debug */, "resetWarningLightsSelection");
}
exports.resetWarningLightsSelection = resetWarningLightsSelection;
function scrollToBottom() {
    window.scrollTo(0, document.body.scrollHeight);
}
exports.scrollToBottom = scrollToBottom;
;
function scrollToTop() {
    window.scrollTo(0, 0);
}
exports.scrollToTop = scrollToTop;
;
function handleAlertAreaDisplay(message) {
    if ($(exports._infoBar).length === 0) {
        return;
    }
    var show = false;
    if (message) {
        message = message.trim();
        if (message.slice(-1) === ",") {
            message = message.slice(0, -1);
        }
        show = true;
        // use html not text prop set
        $(exports._infoBar).html(message);
    }
    else {
        if ($(exports._infoBar).find(".validation-summary-valid > li:visible").length === 0) {
            $(exports._infoBar).find(".validation-summary-errors").hide();
        }
        else {
            $(exports._infoBar).find(".validation-summary-errors").show();
            show = true;
        }
        // check for .net validators triggers and js pushed errors
        if ($(exports._infoBar).find(".validation-summary-valid li").text()) {
            show = true;
        }
        else {
            show = $(exports._infoBar).children().length > 0;
        }
    }
    if (show) {
        scrollToElement(exports._alertArea);
        $(exports._alertArea).fadeIn().removeClass("hidden");
        setUiState("Ready" /* Ui.Ready */);
        (0, logging_1.log)("scrolled to alertArea", 4 /* LogType.Debug */, "handleAlertAreaDisplay");
    }
    else {
        $(exports._alertArea).hide();
        (0, logging_1.log)("hidden alertArea", 4 /* LogType.Debug */, "handleAlertAreaDisplay");
    }
}
exports.handleAlertAreaDisplay = handleAlertAreaDisplay;
;
function clearAndHideInfoBar() {
    $(exports._infoBar).empty();
    handleAlertAreaDisplay();
}
exports.clearAndHideInfoBar = clearAndHideInfoBar;
;
function isPostalAreaValid(postalArea) {
    var postalAreaRegex = /^([a-zA-Z]){1}([0-9][0-9]|[0-9]|[a-zA-Z][0-9][a-zA-Z]|[a-zA-Z][0-9][0-9]|[a-zA-Z][0-9])\s?([0-9]?[a-zA-z]?[a-zA-z]?)?$/;
    var result = postalAreaRegex.test(postalArea);
    (0, logging_1.log)("Invoked, input: " + postalArea + " | result: " + result, 4 /* LogType.Debug */, "isPostalAreaValid");
    return result;
}
exports.isPostalAreaValid = isPostalAreaValid;
;
function isPostcodeValid(postcode, sourceField) {
    var postcodeRegex = /^([a-zA-Z]){1}([0-9][0-9]|[0-9]|[a-zA-Z][0-9][a-zA-Z]|[a-zA-Z][0-9][0-9]|[a-zA-Z][0-9])\s?([0-9][a-zA-z][a-zA-z]){1}$/;
    var result = postcodeRegex.test(postcode);
    (0, logging_1.log)("Invoked, input: " + postcode + " | result: " + result, 4 /* LogType.Debug */, "isPostcodeValid");
    if (sourceField) {
        $(sourceField).toggleClass("input-validation-error", !result);
    }
    return result;
}
exports.isPostcodeValid = isPostcodeValid;
;
function hasValue(toTest) {
    var result;
    if (Array.isArray(toTest)) {
        var validCount = 0;
        toTest.forEach(function (item, index) {
            validCount = toTest !== null ? validCount + 1 : validCount;
        });
        result = validCount === toTest.length;
    }
    else {
        result = toTest !== null;
    }
    (0, logging_1.log)("input: " + toTest + " | output: " + result, 4 /* LogType.Debug */, "hasValue");
    return result;
}
exports.hasValue = hasValue;
function processQueryStringParameters(url, parameters) {
    if (url !== null && parameters !== null) {
        var paramsAddedCount = 0;
        for (var i = 0; i < parameters.length; i++) {
            var param = parameters[i];
            if (param !== null) {
                var kvp = param.split("|");
                if (kvp.length === 2 && !!kvp[0] && !!kvp[1]) {
                    var marker = paramsAddedCount === 0 ? "?" : "&";
                    url += "".concat(marker).concat(kvp[0], "=").concat(kvp[1]);
                    paramsAddedCount++;
                }
            }
        }
        console.info("Built querystring url: " + url);
    }
    return url;
}
exports.processQueryStringParameters = processQueryStringParameters;
function setUiState(state) {
    if (state === "Busy" /* Ui.Busy */) {
        $(".loading").show();
    }
    else {
        $(".loading").fadeOut("fast");
    }
    (0, logging_1.log)("Invoked, set Ui state to: " + state, 4 /* LogType.Debug */, "setUiState");
}
exports.setUiState = setUiState;
;
function getHiddenFieldValue(targetSelector, fallbackValue) {
    if (!targetSelector) {
        return fallbackValue;
    }
    var $target = $(targetSelector);
    if ($target.length === 0) {
        return fallbackValue;
    }
    return $target.val().toString() ? $target.val().toString() : $target.text();
}
exports.getHiddenFieldValue = getHiddenFieldValue;
;
function setButtonEnabledState(selector, isEnabled) {
    (0, logging_1.log)("enabled: " + isEnabled, 4 /* LogType.Debug */, "setButtonEnabledState");
    if (isEnabled) {
        $(selector).removeAttr("disabled");
    }
    else {
        $(selector).attr("disabled", "true");
    }
}
exports.setButtonEnabledState = setButtonEnabledState;
;
function isFormValid(formToCheck) {
    if (!formToCheck) {
        return true;
    }
    var ok = $(formToCheck).valid();
    return ok;
}
exports.isFormValid = isFormValid;
;
function modifyContentInSection(content, newState) {
    if (content && newState) {
        switch (newState) {
            case "Open" /* UiState.Open */:
                if (!$(content).is(":visible")) {
                    $(content).slideToggle(_slideTransitionInMs);
                }
                $(content).addClass("open").removeClass("closed");
                break;
            case "Close" /* UiState.Close */:
                if ($(content).is(":visible")) {
                    $(content).slideToggle(_slideTransitionInMs);
                }
                $(content).addClass("closed").removeClass("open");
                break;
            case "Toggle" /* UiState.Toggle */:
                $(content).toggle(_transitionInMs);
                if ($(content).is(":visible")) {
                    $(content)
                        .addClass("open")
                        .removeClass("closed");
                }
                else {
                    $(content)
                        .addClass("closed")
                        .removeClass("open");
                }
                break;
        }
    }
}
exports.modifyContentInSection = modifyContentInSection;
;
function isValidEmail(email) {
    // this is a deliberately simple regex to catch the 
    // obviously errors when inputting email, a bulletproof regex for email is 
    // notoriously painful and out of scope for this usage
    var regex = /\S+@\S+\.\S+/;
    var result = regex.test(email);
    (0, logging_1.log)("input: " + email + " => " + result, 4 /* LogType.Debug */, "isValidEmail");
    return result;
}
exports.isValidEmail = isValidEmail;
;
function modifySection(section, newState, scrollToAfter) {
    (0, logging_1.log)("section: " + $(section).attr("id") + " | state: " + newState, 4 /* LogType.Debug */, "modifySection");
    if (!section) {
        return;
    }
    var requiresChange = !$(section).hasClass(newState === "Open" /* UiState.Open */ ? "open" : "closed");
    if (requiresChange) {
        switch (newState) {
            case "Open" /* UiState.Open */:
                $(section).addClass("open").removeClass("closed");
                break;
            case "Close" /* UiState.Close */:
                $(section).addClass("closed").removeClass("open");
                break;
            case "Toggle" /* UiState.Toggle */:
                $(section).toggleClass("open closed");
                break;
        }
        var $content = $(section).parent().find(".content");
        modifyContentInSection($content, newState);
    }
    else {
        (0, logging_1.log)("No change to section required - UiState already set.", 4 /* LogType.Debug */, "modifySection");
    }
    if (scrollToAfter) {
        scrollToElement(section);
    }
}
exports.modifySection = modifySection;
;
function scrollToElement(elementSelector) {
    if (elementSelector && $(elementSelector).length > 0) {
        (0, logging_1.log)("scrolling to element: " + elementSelector, 4 /* LogType.Debug */, "scrollToElement");
        var headerHeight = $(".page-header").height() || 0;
        $("html,body").animate({ scrollTop: $(elementSelector).offset().top - headerHeight }, "slow");
    }
}
exports.scrollToElement = scrollToElement;
;
function vehicleHasServicePack() {
    return $('#VehicleHasStandardServicePack').val() || $('#VehicleHasStandardServicePack').val();
}
exports.vehicleHasServicePack = vehicleHasServicePack;
;
function showOverlay(content, modalSize) {
    (0, logging_1.log)("Fired.", 4 /* LogType.Debug */, "showOverlay");
    setUiState("Ready" /* Ui.Ready */);
    if (content === null || content.length === 0) {
        return;
    }
    if (modalSize === null || modalSize === undefined) {
        $(".modalOuter").removeClass("small" /* ModalSize.Small */);
        $(".modalOuter").removeClass("large" /* ModalSize.Large */);
    }
    else {
        $(".modalOuter").addClass(modalSize);
        switch (modalSize) {
            case "small" /* ModalSize.Small */:
                $(".modalOuter").removeClass("large" /* ModalSize.Large */);
                break;
            case "medium" /* ModalSize.Medium */:
                $(".modalOuter").removeClass("small" /* ModalSize.Small */);
                $(".modalOuter").removeClass("large" /* ModalSize.Large */);
                break;
            case "large" /* ModalSize.Large */:
                $(".modalOuter").removeClass("small" /* ModalSize.Small */);
                break;
        }
    }
    $(".modalInner").html(content);
    $(".modal").addClass("modalOpen");
    $("body").addClass("modalBody");
    $(".modalClose.js-close-modal").show();
}
exports.showOverlay = showOverlay;
;
function hideOverlay() {
    (0, logging_1.log)("Fired.", 4 /* LogType.Debug */, "hideOverlay");
    setUiState("Ready" /* Ui.Ready */);
    $(".modalOuter").removeClass("large");
    $(".modal").removeClass("modalOpen");
    $("body").removeClass("modalBody");
}
exports.hideOverlay = hideOverlay;
;
var triggerExpander = function triggerExpander() {
    console.log('triggerExpander');
};
function centreElement(element) {
    element.css("position", "absolute");
    element.css("top", Math.max(0, (($(window).height() - $(element).outerHeight()) / 2) + $(window).scrollTop()) + "px");
    element.css("left", Math.max(0, (($(window).width() - $(element).outerWidth()) / 2) + $(window).scrollLeft()) + "px");
}
exports.centreElement = centreElement;
;
function loadProgressAnimation() {
    lottie_web_1.default.loadAnimation({
        container: document.getElementById('loaderAnimate'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animator
    });
}
;
function setupBasket() {
    var EstimateBasketDisplay = (function () {
        function EstimateBasketDisplay() {
            var _this = this;
            this.window = $(window);
            this.toggleButton = $('.appointmentHead');
            this.toggleButtonLower = $('.closer.no-progress');
            this.toggleTarget = $('.expandedBasket');
            if (window.innerWidth < 768) {
                this.toggleTarget.hide();
                this.toggleButton.addClass("closed");
            }
            this.toggleButton.on('click', function (e) {
                _this.toggleTarget.toggle();
                _this.toggleButton.toggleClass("closed");
                return false;
            });
            this.toggleButtonLower.on('click', function (e) {
                _this.toggleTarget.toggle();
                _this.toggleButtonLower.toggleClass("closed");
                scrollToTop();
                return false;
            });
            this.window.resize(function () {
                if (window.matchMedia("(min-width: 768px)").matches) {
                    _this.toggleTarget.show();
                    _this.toggleButton.removeClass("closed");
                    return;
                }
            });
        }
        return EstimateBasketDisplay;
    }());
    var estimateBasket = new EstimateBasketDisplay();
}
exports.TabbedContent = (function () {
    function TabbedContent(options) {
        var _this = this;
        this.settings = {
            targetDiv: '',
            tabSelectedClass: 'selected',
            content: [],
            targetTab: '',
            selectedDiv: ''
        };
        this.handleClickEvent = function (element) {
            var parentElementClicked = element.target.parentNode;
            var parentNodeID = '#' + parentElementClicked.getAttribute('ID');
            //If we've hit the show all services pill, loop through the other options and display them all
            if (parentNodeID == "#allServicesTab") {
                var idArray = [];
                $("#moreContent div[id*='Content']").each(function () {
                    idArray.push("#" + $(this).attr('id'));
                });
                _this.showHideContentEventAll(idArray, parentNodeID, _this.settings);
                // Hide the 'all services' module
                $('[elementLinkId=serviceAll]').hide();
            }
            //If not, show the individual options
            else {
                var divToShow = _this.getTheElementToShow(element.target.href); // Returns the ID from the URL
                _this.showHideContentEvent(divToShow, parentNodeID, _this.settings);
                // Show the 'all services' module
                $('[elementLinkId=serviceAll]').show();
            }
            element.preventDefault();
        };
        if (options) {
            $.extend(this.settings, options); // Overwrites the default settings with those defined in the function call (options object)
        }
        this.cachedTargetID = document.querySelector(this.settings.targetDiv);
        this.hideContent(this.settings);
        this.initialView(this.settings);
        this.addClickEvents(this.settings);
    }
    TabbedContent.prototype.hideContent = function (settings) {
        var numberOfTabbedContent = settings.content.length;
        for (var count = 0; count < numberOfTabbedContent; count++) {
            $(settings.content[count]).css({ 'display': 'none' });
        }
    };
    TabbedContent.prototype.initialView = function (settings) {
        $(settings.targetTab).addClass(settings.tabSelectedClass);
        $(settings.selectedDiv).css({ 'display': 'block' });
    };
    TabbedContent.prototype.addClickEvents = function (settings) {
        var clickableElements = this.cachedTargetID.getElementsByTagName('a');
        var numberOfClickableElements = clickableElements.length;
        for (var count = 0; count < numberOfClickableElements; count++) {
            clickableElements[count].addEventListener('click', this.handleClickEvent);
        }
    };
    TabbedContent.prototype.getTheElementToShow = function (fullURL) {
        var theURL = '[\\#]([^&#]*)';
        var regex = new RegExp(theURL);
        var tabHrefID = regex.exec(fullURL);
        return tabHrefID[0];
    };
    TabbedContent.prototype.showHideContentEvent = function (elementToShow, tabClicked, settings) {
        if (elementToShow != settings.selectedDiv) {
            // Update display state for all Content
            $("#moreContent div[id*='Content']").each(function () {
                $(this).css({ 'display': 'none' });
            });
            // Displays the content
            $(settings.selectedDiv).css({ 'display': 'none' });
            $(elementToShow).css({ 'display': 'block' });
            settings.selectedDiv = elementToShow;
            // Changes the class on the tabs
            $("#allOptionsTabs li[id*='Tab']").each(function (item) {
                $(this).removeClass(settings.tabSelectedClass);
            });
            $(tabClicked).addClass(settings.tabSelectedClass);
            settings.targetTab = tabClicked;
        }
    };
    TabbedContent.prototype.showHideContentEventAll = function (elementsToShow, tabClicked, settings) {
        // Remove selected state from all tabs
        $("#allOptionsTabs li[id*='Tab']").each(function (item) {
            $(this).removeClass(settings.tabSelectedClass);
        });
        if (elementsToShow.length > 0) {
            // Set allServices tab to selected
            $(tabClicked).addClass(settings.tabSelectedClass);
            elementsToShow.forEach(function (item) {
                // Displays all content
                $(item).css({ 'display': 'block' });
            });
        }
        settings.selectedDiv = "";
    };
    TabbedContent.prototype.setActiveTab = function (tabId) {
        var divToShow = this.getTheElementToShow($(tabId + ' a').attr('href')); // Returns the ID from the URL
        this.showHideContentEvent(divToShow, tabId, this.settings);
    };
    return TabbedContent;
}());
function setupFooterControl() {
    var FooterControl = (function () {
        function FooterControl() {
            this.footerNavButtons = $(".footerNav h2");
            this.footerNavButtons.on("click", function (e) {
                // hide, outerHeight, toggle and show forces a redraw on Safari - otherwise the arrows look stuck.
                $(e.target).hide();
                $(e.target).outerHeight();
                $(e.target).toggleClass("open");
                $(e.target).show();
                $(e.target).parent().children("ul").toggleClass("open");
            });
        }
        return FooterControl;
    }());
    var footerControl = new FooterControl();
}
function setupAlertArea() {
    var alertAreaControl = new alert_control_1.AlertControl();
    var readMoreControl = new read_more_control_1.ReadMoreControl();
}
function bindFormSubmit() {
    $("form").on("submit", function (ev) {
        if (!isFormValid(this)) {
            setUiState("Ready" /* Ui.Ready */);
            (0, logging_1.log)("Form invalid, hiding progress spinner, preventing form submit.", 4 /* LogType.Debug */, "{ event } form submit");
            return false;
        }
        else {
            setUiState("Busy" /* Ui.Busy */);
            (0, logging_1.log)("Form valid, showing progress spinner.", 4 /* LogType.Debug */, "{ event } form submit");
        }
    });
}
exports.bindFormSubmit = bindFormSubmit;
function setupCookieBannerObserver() {
    var target = document.querySelector('#bmw-eprivacy-banner');
    var observer = new MutationObserver(function () {
        var buttons = $(".bmw-eprivacy-banner__ctas").find("button");
        $(".cookie-banner").toggleClass("tinted", buttons.length > 0);
    });
    // configuration of the observer
    var config = { attributes: true, childList: true, characterData: true, subtree: true };
    observer.observe(target, config);
}
function setupAccordions() {
    $(document).on("click", ".accordion", function (ev) {
        var source = $(this);
        source.toggleClass("closed");
        source.parent().find(".accordionContent").toggle();
    });
}
